<template>
  <div>
    <v-card width="500" class="mx-auto mt-8">
      <v-card-title>
        <v-row justify="center">
          Registrar delegado
        </v-row>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="px-8" >
        <v-progress-linear v-if="loading" indeterminate class="my-2"></v-progress-linear>
        <v-row>
          <v-col cols="11">
            <v-text-field
            v-model="delegado.nombreTitular"
            label="Titular"
            readonly
            @click="findEmpleado(true)">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pr-0" cols="11">
            <v-text-field
            v-model="delegado.nombreDelegado"
            label="Delegado"
            readonly
            @click="findEmpleado(false)">
            </v-text-field>
          </v-col>
          <v-col cols="1">
            <v-tooltip bottom activator="#btn-remove">
              Quitar delegado
            </v-tooltip>
            <v-btn class="mr-2" id="btn-remove" :disabled="disabledBorrar" icon small fab @click="openDlgBorrar()">
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row justify="center">
          <v-btn small outlined color="primary" :disabled="disabledSave" @click="saveDelegado">
            <v-icon left>
              mdi-content-save-outline
            </v-icon>
            Guardar
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>

    <dialog-find-empleado :show.sync="showFind" @selected="selectedEmpleado($event)"></dialog-find-empleado>

    <dialog-message :show.sync="showDialog" :color="colorDlg" :title="titleDlg">
      {{ mensaje }}
    </dialog-message>

    <dialog-confirmar :show="showDlgConfirmar" @selected="confirmarBorrar($event)">
      {{ mensaje }}
    </dialog-confirmar>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import axios from "axios";
import DialogFindEmpleado from '@/components/dialogs/DialogFindEmpleado.vue';
import DialogMessage from "@/components/dialogs/DialogMessage.vue";
import DialogConfirmar from "@/components/dialogs/DialogConfirmar.vue";
export default {
  components: {
    DialogFindEmpleado,
    DialogMessage,
    DialogConfirmar
  },
  data() {
    return {
      empTitular: null,
      empDelegado: null,
      empSearch: null,
      disabledSave: true,
      disabledBorrar: true,
      mensaje: "Mensaje",
      colorDlg: "primary",
      titleDlg: "Aviso",
      showDialog: false,
      showFind: false,
      showDlgConfirmar: false,
      loading: false,
      delegado: null,
      findTit: false,
      findDele: false
    }
  },
  computed: {
    ...mapState(["usuario"])
  },
  watch: {
    empSearch() {
      this.getDelegado();
    }
  },
  methods: {
    getDelegado() {
      let numEmpleado = this.empSearch.numEmpleado;
      this.loading = true;
      axios.get(`/delegado?numEmpTitular=${numEmpleado}&modo=private`)
      .then(response => {
        this.loading = false;
        this.delegado = response.data;
        this.disabledSave = true;
        this.disabledBorrar = !this.delegado || this.delegado.numEmpDelegado === 0;
      })
      .catch(error => {
        this.loading = false;
        if (error.response) {
          if (error.response.status === 404) {
            let emp = this.empSearch;
            this.delegado = {
              numEmpTitular: emp.numEmpleado,
              numEmpDelegado: 0,
              nombreTitular: emp.apellidoPat+ " "+ emp.apellidoMat+ " "+ emp.nombres,
              nombreDelegado: "",
              claveAdscTitular: "",
              nivelMandoDelegado: 0
            }
          } else {
            this.showError(error.response.data);
          }
        } else {
          this.showError("Error al acceder al servidor. No se guardaron los cambios.");
          console.log(error);
        }
      })
    },
    saveDelegado() {
      this.loading = true;
      axios.post("/delegado", this.delegado)
      .then(response => {
        this.loading = false;
        if (response) {
          this.disabledSave = true;
          this.disabledBorrar = !this.delegado || this.delegado.numEmpDelegado === 0;
          this.showInfo("Se guardaron los cambios.");
        }
      })
      .catch(error => {
        this.loading = false;
        if (error.response) {
          this.showError(error.response.data);
        } else {
          this.showError("Error al acceder al servidor. No se guardaron los cambios.");
          console.log(error);
        }
      })
    },
    quitarDelegado() {
      this.loading = true;
      axios.delete(`/delegado?numEmpTitular=${this.delegado.numEmpTitular}`)
      .then(response => {
        this.loading = false;
        if (response) {
          this.delegado.numEmpDelegado = 0;
          this.delegado.nombreDelegado = "";
          this.disabledBorrar = !this.delegado || this.delegado.numEmpDelegado === 0;
          this.showInfo("Se quitó el delegado.");
        }
      })
      .catch(error => {
        this.loading = false;
        if (error.response) {
          this.showError(error.response.data);
        } else {
          this.showError("Error al acceder al servidor. No se guardaron los cambios.");
          console.log(error);
        }
      })
    },
    findEmpleado(titular) {
      this.findTit = titular;
      this.findDele = !titular;
      this.showFind = true;
    },
    selectedEmpleado(emp) {
      if (this.findTit) {
        this.empSearch = emp;
      } else {
        this.delegado.numEmpDelegado = emp.numEmpleado;
        this.delegado.nombreDelegado = emp.apellidoPat+ " "+ emp.apellidoMat+ " "+ emp.nombres;
        this.disabledSave = !this.delegado || this.delegado.numEmpDelegado === 0;
        this.disabledBorrar = true;
      }
    },
    openDlgBorrar() {
      this.mensaje = "¿Quitar al delegado?";
      this.showDlgConfirmar = true;
    },
    confirmarBorrar(value) {
      this.showDlgConfirmar = false;
      if (value) {
        this.quitarDelegado();
      }
    },
    showError(message) {
      this.mensaje = message;
      this.colorDlg = "error";
      this.titleDlg = "Error",
      this.showDialog = true;
    },
    showWarning(message) {
      this.mensaje = message;
      this.colorDlg = "accent";
      this.titleDlg = "Revisar",
      this.showDialog = true;
    },
    showInfo(message) {
      this.mensaje = message;
      this.colorDlg = "primary";
      this.titleDlg = "Aviso",
      this.showDialog = true;
    },
  },
  created() {
    this.delegado = {
      numEmpTitular: 0,
      numEmpDelegado: 0,
      nombreTitular: "",
      nombreDelegado: "",
      claveAdscTitular: "",
      nivelMandoDelegado: 0
    }
  }
}
</script>